import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import $ from "jquery";
import ModalD from "react-awesome-modal";
import * as moment from "moment";
import { isApiResponse } from '../../helpers/utils.js';
class DownloadReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            model_visible : false,
            file_url: '',
            rfile: '',
            fetch_data:false,
        }

    }

    componentDidMount() {

    }
    downLoadReport (filters, endpoint, name, range){

        var that = this;
        var a = moment(filters.end_date);
        var b = moment(filters.start_date);
        var days_beet = a.diff(b, 'days');
        if(range === -1) {
            // -1 sentinel = no date-range limit
        } else if(range === undefined || range === 'undefined' || range === '' || range === null)
        {
            if(days_beet>config.get('REPORT_CSV_DAYS_LIMIT')) {
                alert("Date range too large. Please select a date range of "+ config.get('REPORT_CSV_DAYS_LIMIT')+ " days at a time");
                return false;
          }
        } else {
            if(days_beet>range) {
                alert("Date range too large. Please select a date range of "+ range+ " days at a time");
                return false;
            }
        }

        this.setState({
            is_download: false,
            model_visible: true,
            file_url: '',
            rfile: '',
            fetch_data:false
        });

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/report-csv-download",
            type: "POST",
            data: {
                filters: filters,
                endpoint: endpoint
            },
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },

            success: function (response, status, xhr) {
              this.copyEodFile(response.data, name);
                this.setState({
                    fetch_data:true
                })
            }.bind(this),
            error: function(data) {
                that.closeModal();
                alert("Failed to download data. Please try again");
            }
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    copyEodFile (remotePath,name){
       var postData = {
            remotePath: remotePath
        }

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/copy-file",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = new Date().getTime()+name+'.csv.gz';
                let rfile = fileName.replace(/\"/g, "");
                //console.log(fileName)
                //let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                // a.href = url;
                // a.download = rfile;
                // a.click();
                // window.URL.revokeObjectURL(url);
                this.setState({
                    is_download: true,
                    file_url: url,
                    rfile: rfile
                })
            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    downloadFile(e){
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.url);
    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }

    render() {
        return(
        <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
            <div className="download-popup-model">
                <div className="message-content">
                    {this.state.file_url==''?
                        <div>
                            {this.state.fetch_data===false?
                            <p>Fetching Data & Generating CSV…</p>:<p>Fetching File. Please wait…</p>}
                            <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                <i className="fa fa-times-circle" aria-hidden="true"></i>Cancel
                            </a>
                        </div>

                        :
                        <div className="dwnloadLink">
                            <a href="#" onClick={this.downloadFile.bind(this)}>
                                <i className="fa fa-download" aria-hidden="true"></i>Download
                            </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                            </a>
                        </div>
                    }
                </div>
            </div>
        </ModalD>

        );
    }
}

export default DownloadReport